import {
  useEffect,
  useState,
} from "react";

import {
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import { useAuth } from "../../AuthContext";
import { supabase } from "../../supabaseClient";

export default function RequireBusiness() {
  const { user } = useAuth();

  const location =
    useLocation();

  const [
    checking,
    setChecking,
  ] = useState(true);

  const [
    onboardingComplete,
    setOnboardingComplete,
  ] = useState(false);

  useEffect(() => {
    let alive = true;

    async function checkOnboarding() {
      if (!user?.id) {
        if (alive) {
          setOnboardingComplete(false);
          setChecking(false);
        }

        return;
      }

      try {
        setChecking(true);

        const {
          data,
          error,
        } = await supabase
          .from(
            "user_onboarding_profile"
          )
          .select(
            "onboarding_completed_at"
          )
          .eq(
            "user_id",
            user.id
          )
          .maybeSingle();

        if (error) {
          throw error;
        }

        if (!alive) return;

        setOnboardingComplete(
          Boolean(
            data?.onboarding_completed_at
          )
        );

        setChecking(false);
      } catch (error) {
        console.error(
          "Onboarding completion check failed:",
          error
        );

        if (alive) {
          setOnboardingComplete(false);
          setChecking(false);
        }
      }
    }

    checkOnboarding();

    return () => {
      alive = false;
    };
  }, [user?.id]);

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FFF7ED] px-6">
        <p className="text-sm font-semibold text-[#757575]">
          Checking your profile...
        </p>
      </div>
    );
  }

  if (!onboardingComplete) {
    return (
      <Navigate
        to="/profile-gate"
        replace
        state={{
          from: location,
        }}
      />
    );
  }

  return <Outlet />;
}